import React, { FC, InputHTMLAttributes } from "react"
import * as classes from "./Time.module.scss"

const Time: FC<InputHTMLAttributes<HTMLInputElement>> = props => (
  <input
    className={`${classes.Time} ${props.className ? props.className : ""}`}
    type="time"
    {...props}
  />
)
export default Time
